import React from 'react';
import user from '../Auth/user';
import firebase from '../firebase';
import compose from '../compose';
import { translate } from 'react-i18next';
import {Card, CardText} from 'material-ui/Card';
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import { Link } from 'react-router-dom';
import LoadingIndicator from '../Navigation/LoadingIndicator';
import ProductAvatar from '../Product/ProductAvatar';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import PriceDialog from './PriceDialog';
import AddStockDialog from './AddStockDialog';

class ProductsCard extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      standKey: null,
      products: [],
      loadingIndicator: 'flex',
      priceDialog: false,
      addStockDialog: false,
      dialogProduct: null
    };

    this.state = {
      ...this.initialState
    };
  }
  componentDidMount = () => {
    const {firebase} = this.props;
    const {standKey} = this.props;
    const {shopkeeperId} = this.props.user;
    if(standKey) {
      this.setState({standKey});
    }

    if(shopkeeperId) {
      if (!this.standProductsRef) {
        this.standProductsRef = firebase.database().ref(`shopkeepers/${shopkeeperId}/stands/${standKey}/products`).orderByChild('name');
        this.standProductsRef.on('child_added', this.addProduct);
        this.standProductsRef.on('child_changed', this.changeProduct);
        this.standProductsRef.on('child_removed', this.removeProduct);
        this.standProductsRef.once('value').then(this.setState({loadingIndicator: 'none'}));
      }
    }
  }
  componentWillUnmount = () => {
    if (this.standProductsRef) {
      this.standProductsRef.off('child_added');
      this.standProductsRef.off('child_changed');
      this.standProductsRef.off('child_removed');
    }
  }
  addProduct = (data) => {
    const {firebase} = this.props;
    let product = {
      key: data.key,
      ...data.val()
    };

    const currentProducts = this.state.products.slice();
    product.pictureUrl = '';
    currentProducts.push(product);
    this.setState({products: currentProducts});

    if (product.picture) {
      firebase.storage().ref(product.picture).getDownloadURL().then((url) => {
        product.pictureUrl = url;
        const currentProducts = this.state.products.slice();
        const index = currentProducts.findIndex((item) => (item.key === product.key));
        currentProducts[index] = product;
        this.setState({products: currentProducts});
      });
    }

  }
  changeProduct = (data) => {
    const {firebase} = this.props;
    const product = {
      key: data.key,
      ...data.val()
    };

    if (product.picture) {
      firebase.storage().ref(product.picture).getDownloadURL().then((url) => {
        product.pictureUrl = url;
        const currentProducts = this.state.products.slice();
        const index = currentProducts.findIndex((item) => (item.key === product.key));
        currentProducts[index] = product;
        this.setState({products: currentProducts});
      }).catch(() => {
        product.pictureUrl = '';
        const currentProducts = this.state.products.slice();
        const index = currentProducts.findIndex((item) => (item.key === product.key));
        currentProducts[index] = product;
        this.setState({products: currentProducts});
      }
      );
    } else {
      product.pictureUrl = '';
      const currentProducts = this.state.products.slice();
      const index = currentProducts.findIndex((item) => (item.key === product.key));
      currentProducts[index] = product;
      this.setState({products: currentProducts});
    }

  }
  removeProduct = (data) => {
    const currentProducts = this.state.products.slice();
    const index = currentProducts.findIndex((item) => (item.key === data.key));
    currentProducts.splice(index, 1);
    this.setState({products: currentProducts});
  }
  handlePriceDialogClose = () => {
    this.setState({priceDialog: false});
  }
  handlePriceDialogOpen = () => {
    this.setState({priceDialog: true});
  }
  handleAddStockClose = () => {
    this.setState({addStockDialog: false});
  }
  handleAddStockOpen = () => {
    this.setState({addStockDialog: true});
  }
  handleCellClick = (row,column, event) => {
    var rect = event.target.getBoundingClientRect();

    const isPriceColumn = column === 2;
    const isStockColumn = column === 3;
    const isHeaderRow = row === 0;
    const isEditableCell = rect.height < 20;

    if ((!isPriceColumn && !isStockColumn) || isHeaderRow || !isEditableCell) return;

    const eventPosition = this.clickPosition(rect);

    if (isPriceColumn) {
      this.setState({dialogProduct: this.state.products[row-1],
        priceDialog: true,
        eventPosition});
    } else {
      this.setState({dialogProduct: this.state.products[row-1],
        addStockDialog: true,
        eventPosition});
    }
  }
  clickPosition = (rect) => {
    const maxDialogWidth = 310;
    const maxDialogHeight = 330;
    const dialogHeight = 300;
    const topBarHeight = 64;

    let x = 0;
    if (rect.left + maxDialogWidth > window.innerWidth) {
      x = window.innerWidth - maxDialogWidth;
    } else if (rect.left - maxDialogWidth > 0) {
      x = rect.left;
    }

    let y = 0;
    if (rect.top + dialogHeight > window.innerHeight) {
      y = window.innerHeight - maxDialogHeight;
    } else if (rect.top - topBarHeight > 0) {
      y = rect.top - topBarHeight;
    }

    let eventPosition = {x, y};

    return eventPosition;
  }
  render() {
    const {t} = this.props;
    const products =
    this.state.products.map((product) => (
      <TableRow key={product.key}>
        <TableRowColumn className='hidden-xs' style={{ width: 24 }}>
          <ProductAvatar src={product.pictureUrl} name={product.name} />
        </TableRowColumn>
        <TableRowColumn style={{whiteSpace: 'normal', wordWrap: 'break-word'}}>
          {product.name}
        </TableRowColumn>
        <TableRowColumn className='hidden-xs'>
          <span style={{fontFamily: 'Roboto Mono, monospace', textAlign: 'right', borderBottom: '1px solid #BDBDBD', display: 'block', cursor: 'pointer'}}>
            {Number(product.price).toFixed(2) + ' €'}
          </span>
        </TableRowColumn>
        <TableRowColumn style={{paddingRight: 30}}>
          <span style={{fontFamily: 'Roboto Mono, monospace', textAlign: 'right', borderBottom: '1px solid #BDBDBD', display: 'block', cursor: 'pointer'}}>
            {product.totalCount | 0}
          </span>
        </TableRowColumn>
        <TableRowColumn>
          <IconMenu
            iconButtonElement={<IconButton touch={true}><MoreVertIcon /></IconButton>}
            useLayerForClickAway={true}
            anchorOrigin={{horizontal: 'right', vertical: 'top'}}
            targetOrigin={{horizontal: 'right', vertical: 'top'}}>
            <MenuItem
              primaryText={t('product.edit')}
              containerElement={<Link to={`/products/${product.key}/`} />}/>
          </IconMenu>
        </TableRowColumn>
      </TableRow>
    ));
    return (
      <Card className='cardStyle'>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text={t('product.products')} />
          </ToolbarGroup>
          <ToolbarGroup lastChild={true}>
            <IconMenu
              iconButtonElement={<IconButton touch={true}><MoreVertIcon /></IconButton>}
              useLayerForClickAway={true}
              anchorOrigin={{horizontal: 'right', vertical: 'top'}}
              targetOrigin={{horizontal: 'right', vertical: 'top'}}>
              <MenuItem
                primaryText={t('product.choose')}
                containerElement={<Link to={`/stands/${this.state.standKey}/products`} />}/>
              <MenuItem
                primaryText={t('product.addStocks')}
                containerElement={<Link to={`/stands/${this.state.standKey}/addStocks`} />}/>
              <MenuItem
                primaryText={t('inventory.start')}
                containerElement={<Link to={`/stands/${this.state.standKey}/stocktaking`} />}/>
            </IconMenu>
          </ToolbarGroup>
        </Toolbar>
        <CardText>
          <Table style={{tableLayout: 'auto'}} onCellClick={this.handleCellClick}>
            <TableBody displayRowCheckbox={false} >
              <TableRow>
                <TableRowColumn className='hidden-xs' style={{ width: 24 }}> </TableRowColumn>
                <TableRowColumn style={{color: '#9e9e9e'}}>{t('product.product')}</TableRowColumn>
                <TableRowColumn style={{textAlign: 'center', color: '#9e9e9e'}} className='hidden-xs'>{t('price')}</TableRowColumn>
                <TableRowColumn style={{textAlign: 'center', color: '#9e9e9e'}}>{t('stock')}</TableRowColumn>
                <TableRowColumn> </TableRowColumn>
              </TableRow>
              {products}
            </TableBody>
          </Table>
          <LoadingIndicator display={this.state.loadingIndicator} />
        </CardText>
        <PriceDialog
          open={this.state.priceDialog}
          handleClose={this.handlePriceDialogClose}
          product={this.state.dialogProduct}
          standKey={this.state.standKey}
          eventPosition={this.state.eventPosition}/>
        <AddStockDialog
          open={this.state.addStockDialog}
          handleClose={this.handleAddStockClose}
          product={this.state.dialogProduct}
          standKey={this.state.standKey}
          eventPosition={this.state.eventPosition}/>
      </Card>

    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(ProductsCard);



// WEBPACK FOOTER //
// ./src/Stand/ProductsCard.js